module.exports = __webpack_public_path__ + "static/img/assire_var_anahid.c39591f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/assire_var_anahid.png
// module id = unFT
// module chunks = 0